import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface RemoveRecordDialogProps {
    petId: string;
    petName: string;
    chip: string;
    onCancel: () => void;
}

// A public Pet ID or lookup email is not proof of ownership. Continue to the
// authenticated flow; never mutate an owner-wide Customer.io profile flag.
export default function RemoveRecordDialog({ petId, petName, chip, onCancel }: RemoveRecordDialogProps) {
    const navigate = useNavigate();
    return <div className="flex flex-col gap-20">
        <Typography variant="h6">Remove this pet record?</Typography>
        <Typography>Pet: {petName}</Typography>
        <Typography>Microchip ID: {chip}</Typography>
        <Typography>
            Continue securely to verify that you own this record. You may be asked to sign in.
            Then select a removal reason and confirm. Nothing is removed by continuing or signing in.
        </Typography>
        <Button variant="contained" disabled={!petId}
            onClick={() => navigate(`/client/pet/remove/${encodeURIComponent(petId)}`)}>
            Continue to secure removal
        </Button>
        <Button onClick={onCancel}>No, keep record</Button>
    </div>;
}
